import { Foods } from "./foods";
import "../template/style.css"
Foods.getInstance()
